import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'

class CodeLoginFormView extends Component {

  render() {

    document.body.className = window.location.pathname.replace(/\//g," ");

    if (this.props.current_user_id !== undefined){
      return (<Redirect to="/snap-photo" />)
    }else{
      return (

         <div className="width">
            <div className="container topbar">
                <div className="back"><a href="/">« back</a></div>
                <div className="title">Use Code</div>
            </div>
          <div className="padding-10x text-center">
            <form onSubmit={this.props.handleSubmit}>

              <p><Field component="input" type="text" name="pin" placeholder='Enter Code' /></p>

              {this.props.current_user.get("logging_in") === true ?
                  <span>Logging in...</span>
                  :
                  <button type="submit">Sign In</button>
              }

            </form>
            <div className="switch-login">
              <p>Have an email/password? <Link to="/login">Enter It Here</Link></p>
            </div>
          </div>
        </div>

      )
    }
  }
}

CodeLoginFormView.propTypes = {
  //
};

export default reduxForm({form: "CodeLogin"})(CodeLoginFormView);



// WEBPACK FOOTER //
// ./src/snapit_app/components/CodeLoginFormView.js